module.exports = __webpack_public_path__ + "media/chat.ebd3fbfb.wav";